import React,{useMemo} from 'react';
import { Modal, Form, Typography, Button, Checkbox } from "antd";
import { showFull } from '../Helpers/utils';
import { Field, reduxForm } from "redux-form";
import general from '../../const/general'
import { CreateTextField } from '../Helpers/Input/InputCreator';
import certificates from '../../const/certificates';
import { connect } from 'react-redux';
import {email, required} from "../Helpers/Input/validations";


const SignAndShareModal = (props) => {
  const showFullValue = showFull();
  const requiredLanguage = useMemo(() => required(props.language), [props.language]);
  return (
    (<Modal className='sign-share-modal' style={showFullValue ? { top: '15%' } : { top: '5%' }} open={props.modalType !== null}
      width={showFullValue ? 500 : '90%'} {...props.modalProps}>
      <Typography className='size15 color-black'>{props.message}</Typography>
      <Form onFinish={props.handleSubmit(props.onSubmit)}>
        <Field
          name="mail"
          className={'mb-20 mt-20'}
          component={CreateTextField}
          placeholder={general[props.language].mail}
          validate={[requiredLanguage, email]}
          hasFeedback />
        <div className='sign-share-actions'>
          <Checkbox checked={props.dontShowSignAndShare}
            onChange={(e) => props.updateUserSettings({ 'dontShowSignAndShare': e.target.checked })}>
            {certificates[props.language].dontShowAgain}</Checkbox>
          <div className='sign-share-buttons'>
            <Button onClick={props.onSubmit} style={{ justifyContent:'center' }} className='size12 dropdown-button'>
              {general[props.language].noThanks}
            </Button>
            <Button htmlType={'submit'} type={'primary'}>{props.btn}</Button>
          </div>
        </div>

      </Form>
    </Modal>)
  );

}

function mapStateToProps(state) {
  return { dontShowSignAndShare: state.user.dontShowSignAndShare };
} 

export default connect(mapStateToProps, {  })(reduxForm({ form: 'send_and_sign_modal_form' })(SignAndShareModal));